import { OmniaApiState } from "../api/apiState"
import { AuthInterceptor } from "./auth"
import { OmniaHttpService } from "./http"
import { OmniaMaintenanceService } from "./maintenance"
import { getRetryInterceptor } from "./retry"

export function setupInfrastructure(module: ng.IModule) {

    module.service("OmniaApiState", OmniaApiState)
    module.service("OmniaHttpService", OmniaHttpService)
    module.service("OmniaMaintenance", OmniaMaintenanceService)

    module.config(["$httpProvider", $httpProvider => {

        $httpProvider.interceptors.push(AuthInterceptor)
        $httpProvider.interceptors.push(getRetryInterceptor())

        // 200811 - Not enabled yet - would need more work, and does not seem
        // to provide much value in retrospect since Azure returns 403 errors, rather than 503 errors,
        // when an app is stopped
        // $httpProvider.interceptors.push(UnavailableInterceptor)

    }

    ])
}
